import { css } from 'styled-components';
import { CFBaseToggleTokens } from './styles';
export const CFBaseRadioStyles = {
    InputWeb: css `
    margin: 0;
    appearance: none;
  `,
    Root: css `
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    gap: 0;
  `,
    SVGContainer: css `
    width: ${CFBaseToggleTokens.RADIO.CONTAINER_WIDTH}px;
    height: ${CFBaseToggleTokens.RADIO.CONTAINER_HEIGHT}px;
  `,
    SVGContainerWeb: css `
    circle {
      transition-duration: 0.2s;
      transition-timing-function: ease-in-out;
      transition-property: fill, stroke, opacity;
    }
  `,
};
export const CFBaseRadioSVG = {
    Box: {
        cx: 12,
        cy: 12,
        r: 11,
        strokeWidth: 1,
    },
    Radio: {
        cx: 12,
        cy: 12,
        r: 7.2,
    },
    ViewBox: {
        fill: 'none',
        viewBox: '0 0 24 24',
    },
};
